import { responsivePaddingDefault } from '@/libs/material/sx';
import {
    DS_COLOR,
    DS_SHAPE_SPACING,
    DS_WIDTH,
} from '@calm/evexia-design-tokens';
import { Theme } from '@rhg/libs/material';

export const styleOuterWrapper = {
    minHeight: '100dvh',
    width: '100%',
    background: (theme: Theme) => theme.palette.gradient.backgroundPrimary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

export const styleFormOuterWrapper = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

export const styleForm = {
    width: '100%',
};

export const styleContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    flexGrow: 1,
    py: `${DS_SHAPE_SPACING.SECTION}px`,
};
export const styleContent = {
    width: '100%',
    maxWidth: `${DS_WIDTH.FORM_MAX_WIDTH}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mx: responsivePaddingDefault,
};

export const styleAddEditButtonGroup = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    px: responsivePaddingDefault,
};

export const styleAddEditButton = { backgroundColor: 'background.paper' };

export const styleFormIconWrapper = {
    pt: `${DS_SHAPE_SPACING.SECTION}px`,
    mb: `${DS_SHAPE_SPACING.HEADING_CONTENT_MOBILE}px`,
};

export const styleCopyBlock = {
    pb: `${DS_SHAPE_SPACING.SECTION}px`,
};

export const styleVerticalSpacing = { my: `${DS_SHAPE_SPACING.SECTION}px` };

export const ctaFooterStyles = {
    py: 3,
    px: responsivePaddingDefault,
    backgroundColor: (theme: Theme) =>
        // Standalone already has a background
        theme.palette.mode === 'light' ? 'background.paper' : 'transparent',
    borderTop: `1px solid ${DS_COLOR.BLACK_12P}`,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export const styleButtonGroup = {
    maxWidth: `${DS_WIDTH.FORM_MAX_WIDTH}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: `${DS_SHAPE_SPACING.SIDE_SMALL}px`,
};
export const styleFlexGrow = { flexGrow: 1 };
